import StepCard from "@/components/StepCard";
import KnowledgeSourceHeader from "@/partials/create/course/KnowledgeSourceHeader";
import { useTranslation } from "@vixi/localization";
import { RouteOptionsById, RouterIds } from "@vixi/router";
import { ButtonLink, cn, Img, PageMainContent, useGoBack } from "@vixi/ui";

// Assets
import linkedInIcon from "@assets/linkedin.svg";

// Constants
const routeId = "/_app/create/linkedin/" satisfies RouterIds;
const grid_max_width = cn("max-w-269");
const step_card_item = cn("col-span-full md:col-span-6 lg:col-span-4");

export const CreateLinkedinCourseIndexPageOptions: RouteOptionsById<typeof routeId> = {
  component: RouteComponent,
};

function RouteComponent() {
  useGoBack({
    to: "/create",
    replace: true,
  });

  const { t } = useTranslation();

  return (
    <PageMainContent scrollable psY="none">
      <div className={cn(grid_max_width, "m-auto")}>
        <KnowledgeSourceHeader
          title="CreateCourse.LinkedInHeaderTitle"
          subtitle="CreateCourse.LinkedInHeaderSubtitle"
          sourceIcon={<Img src={linkedInIcon} className="-mx-5 h-30.75" />}
        />
        <div className={cn(grid_max_width, "mx-auto")}>
          <h2 className="ar:font-medium mt-7.5 ml-5 font-semibold">
            {t("CreateCourse.KnowledgeSourceStepsTitle")}
          </h2>

          <div className="mt-7.5 grid grid-cols-12 gap-7.5">
            <div className={step_card_item}>
              <StepCard
                stepNumber={1}
                title={"CreateCourse.AddLinkedInContent"}
                description={"CreateCourse.AddLinkedInContentSubtitle"}
              />
            </div>
            <div className={step_card_item}>
              <StepCard
                stepNumber={2}
                title={"CreateCourse.CourseIsGenerated"}
                description={"CreateCourse.CourseIsGeneratedSubtitle"}
              />
            </div>
            <div className={step_card_item}>
              <StepCard
                stepNumber={3}
                title={"CreateCourse.UploadPicture"}
                description={"CreateCourse.UploadPictureSubtitle"}
              />
            </div>
            <div className={step_card_item}>
              <StepCard
                stepNumber={4}
                title={"CreateCourse.ReviewYourCourse"}
                description={"CreateCourse.ReviewYourCourseSubtitle"}
              />
            </div>
            <div className={step_card_item}>
              <StepCard
                stepNumber={5}
                title={"CreateCourse.HitPublish"}
                description={"CreateCourse.HitPublishSubtitle"}
              />
            </div>

            {/* Add the Upload button next to Card 5 */}
            <div className={cn(step_card_item, "flex items-center")}>
              <div className="mx-auto my-2.5 w-max">
                <ButtonLink
                  to="/create/linkedin/flow"
                  size="large"
                  variant="contained"
                  className="px-8 py-4"
                >
                  {t("Action.LetsGetStarted")}
                </ButtonLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageMainContent>
  );
}
